import script from "./CHorizontalProgress.vue?vue&type=script&setup=true&lang=ts"
export * from "./CHorizontalProgress.vue?vue&type=script&setup=true&lang=ts"

import "./CHorizontalProgress.vue?vue&type=style&index=0&id=a061882c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a061882c"]])

export default __exports__